<template>
    <div class="card plain">
        <div class="card-header p-4">
            <h4>{{title}}</h4>
            
            <!-- Left -->
            <el-button
                v-if="showButtonDelete"
                v-permission="[`DELETE_${resource.toUpperCase()}`]"
                type="info"
                round
                class="pull-left mb-4"
                @click="handleDelete()">
                <font-awesome-icon icon="minus" /> Eliminar
            </el-button>
            <el-button
                v-permission="['ASSIGN_RESOURCES_TO_ROL']"
                v-if="showButtonPermissions"
                type="info"
                round
                class="pull-left mb-4"
                @click="handlePermissions()">
                <font-awesome-icon icon="user-plus" /> Asignar Permisos
            </el-button>
            <el-button
                v-if="showButtonArchive"
                type="info"
                round
                class="pull-left mb-4"
                @click="handleArchiveAlert()">
                <i class="el-icon-takeaway-box"></i> Archivar
            </el-button>
            
            <!-- Right -->
            <router-link
                v-if="showCreateButton"
                v-permission="[`CREATE_${resource.toUpperCase()}`]"
                :to="'/panel/settings/' + resource"
                class="btn btn-default btn-round pull-right">
                <font-awesome-icon icon="plus"/> Agregar
            </router-link>
            <el-input placeholder="" v-model="search" class="input-with-select" clearable @input="handleInputSearch">
                <el-select v-model="select" slot="prepend" placeholder="Filter">
                    <el-option :label="$t( resource + '.' + col)" :value="col" v-for="col in colsName" :key="col.id">
                    </el-option>
                </el-select>
            </el-input>
            
        </div> 
        <div class="card-body">
            <el-table
                v-loading="loading"
                ref="multipleTable"
                :data="tableData"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                @sort-change="handleSortChange"
                @row-click="handleRowClick">
                <el-table-column
                    fixed
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column v-for="(col, i) in colsName" :key="i"
                    sortable="custom"
                    with="100"
                    :prop="col"
                    @formatter="formatter"
                    :label="$t( resource + '.' + col)">
                    <template slot-scope="scope">{{ scope.row[col] }}</template>
                </el-table-column>
                <el-table-column 
                    v-if="showButtonStage"
                    fixed="right"
                    sortable="custom"
                    :label="$t('projects.btn_change_stage')">
                    <template slot-scope="scope">
                        <el-tag size="small" effect="dark" type="success">{{scope.row.status}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label=""
                    width="120">
                    <template slot-scope="scope">
                        <router-link
                            v-permission="[`EDIT_${resource.toUpperCase()}`]"
                            v-if="showEditButton"
                            :to="'/panel/settings/'+ resource +'/' + scope.row.id">
                            <i style="font-size: 24px !important;" class="el-icon-edit-outline"></i>
                        </router-link>
                        <div
                            >
                            <i  v-if="showIcon" style="font-size: 24px !important;" :class="scope.row.status=='readed' ? 'el-icon-check' : (scope.row.status=='archived' ? 'el-icon-takeaway-box' : 'el-icon-message')"></i>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="card-footer p-3 m4">
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="pagination.per_page"
                :page-count="pagination.current_page"
                layout="total, prev, pager, next, sizes"
                :total="pagination.total"
                @size-change="handleChangeSizePage"
                >
            </el-pagination>
        </div>
    </div>
</template>
<script>

import { Table, TableColumn, Pagination,
Button, Input, Select, Option, MessageBox,
Message, Drawer, Tag, Progress } from 'element-ui';
import { log } from 'util';
import _ from 'lodash'

import Settings from '@/providers/Settings'
const provider = new Settings()

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Progress.name]: Progress,
        [Button.name]: Button,
        [Select.name]: Select,
        [Option.name]: Option,
        [Input.name]: Input,
        [Pagination.name]: Pagination,
        [Drawer.name]: Drawer,
        [Tag.name]: Tag
    },
    props: {
      title: {
        type: String,
        default: '',
      },
      resource: {
        type: String,
        default: 'projects',
      },
      filters: {
          String
      },
      sotkey: {
          String
      }
    },
    computed: {
        colsName() {
            let resource = this.resource
            let cols = _.find(this.columns, function(c) { return c.name == resource })
            return cols.data
        },
        showButtonDelete() {
            return this.multipleSelection.length > 0 && this.resource !== 'alerts'
        },
        showButtonPermissions() {
            return this.multipleSelection.length > 0 && this.multipleSelection.length < 2 && this.resource == 'roles'
        },
        showButtonStage() {
            return this.resource == 'projects'
        },
        idSelected() {
            return this.multipleSelection.length > 0 ? this.multipleSelection[0].id : null
        },
        showEditButton() {
            return this.resource !== 'alerts'
        },
        showCreateButton() {
            return this.resource !== 'alerts' && this.resource !== 'configurations'
        },
        showIcon(){
            return this.resource == 'alerts'
        },
        showButtonArchive() {
            return this.multipleSelection.length > 0 && this.resource == 'alerts'
        }
    },
    mounted() {
        this.loadData()
    },
    data() {
      return {
        showPanel: true,
        select: this.resource == 'alerts' ? 'subject' : 'name',
        columns: [
            { 
              name: 'users',
              data: [
                'name',
                'email',
                'status',
                'origin',
                'registered_at'
              ]
            },
            { 
              name: 'roles',
              data: [
                'name',
              ]
            },
            { 
              name: 'projects',
              data: [
                'name',
                'ammount_total',
                'ammount_recauded'
              ]
            },
            { 
              name: 'alerts',
              data: [
                'date',
                'subject'
              ]
            },
            { 
              name: 'configurations',
              data: [
                'name'
              ]
            }
        ],
        tableData: [],
        multipleSelection: [],
        pagination: {
          current_page: 1,
          per_page: 10,
          total: 0
        },
        search: '',
        sort: `sort[${this.sotkey || 'id'}]=desc`,
        loading: false,
        stages: []
      }
    },
    methods: {
        loadData() {
            this.loading = true
            let filters = _.clone(this.filters) || ''
            let inputSearch = _.clone(this.search)
            if(inputSearch){
                if (filters && filters.trim() != '') {
                    filters += '&f[' + this.select + ']=' + inputSearch
                }else {
                    filters += 'f[' + this.select + ']=' + inputSearch
                }
            }
            provider.getData(this.resource, this.pagination.per_page, this.pagination.current_page, this.sort, filters).then((response) => {
                this.tableData = response.data.data
                this.pagination = response.data.meta.pagination
                this.loading = false
            }).catch((err) => {
                console.info('error data request')
                console.info(err)
                this.loading = false
            })

            if(this.resource == 'projects') {
                this.getStages()
            }
        },
        getStages() {
            provider.getData('stages', 50, 1).then((response) => {
                let data = response.data.data
                this.stages = data
            }).catch((err) => {
                console.info('error get stages request')
                console.info(err)
            })
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleSortChange(sortConfig){
            let order = sortConfig.column.order == 'descending' ? 'desc' : 'asc'
            let prop = sortConfig.column.property
            this.sort = 'sort['+ prop + ']=' + order
            this.loadData()
        },
        handleCurrentChange(val) {
            this.pagination.current_page = val
            this.loadData()
        },
        handleEdit(index, row) { },
        handleDelete(index, rows) {
            let idSelected = _.map(this.multipleSelection, (ob)=>{
                return ob.id
            });
            if(idSelected.length > 0) {
                let msg = idSelected.length == 1 ? 'el registro seleccionado' : 'los registros seleccionados'

                MessageBox.confirm(`Esto eliminará ${msg}. ¿Continuar?`,
                "Confirmation",
                {
                    confirmButtonText: "Continuar",
                    cancelButtonText: "No",
                    type: "warning"
                }).then(() => {
                    this.loading = true
                    provider.deleteRow(this.resource, idSelected).then((response) => {
                        Message({ type: 'success', message: 'Operación exitosa', effect: "dark" })
                        this.loadData()
                    }).catch((err) => {
                        console.info('error delete request')
                        console.info(err)
                        Message({ type: 'error', message: 'An error ocurred' })
                        this.loading = false
                    })
                }).catch(()=>{
                    this.loading = false
                })
            }
        },
        handleInputSearch() {
            this.loadData()
        },
        handlePermissions() {
            let id = this.multipleSelection[0].id
            this.$router.push('settings/assign/' + id)
        },
        handleChangeStep(proj) {
            let stageName = this.getStageName(proj.stage_id)
            MessageBox.confirm(`¿Cambiar a la etapa ${stageName}?`,
            "Confirmation",
            {
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                type: "warning"
            }).then(() => {
                let stage_id = proj.stage_id
                let id = proj.id
                let data = { stage_id: stage_id }
                provider.changeStage(id, data).then((response) => {
                    Message({ type: 'success', message: 'Operación exitosa' })
                    this.loadData()
                }).catch((err) => {
                    console.info('error change step request')
                    console.info(err)
                    Message({ type: 'error', message: 'An error ocurred' })
                    this.loading = false
                })
            }).catch(() => {})
        },
        handleRowClick(row, column, event) {
            if(this.resource == 'alerts') {
                this.loading = true
                if(row.status == 'unread') {
                    let data = {
                        status: 'readed'
                    }

                    provider.updateAlert(row.id, data).then((response) => {
                        this.loadData()
                    }).catch((err) => {
                        console.info('error change status request')
                        console.info(err)
                        this.loading = false
                    })
                }else {
                    this.loading = false
                }
            }
        },
        handleChangeSizePage (val) {
            this.pagination.per_page = val
            this.loadData()
        },
        handleArchiveAlert () {
            let idSelected = _.map(this.multipleSelection, (ob)=>{
                return ob.id
            });
            if(idSelected.length > 0) {
                let title = idSelected.length == 1 ? 'Archivar notificación ¿Continuar?' : `Se archivarán ${idSelected.length} ¿Continuar?`
                MessageBox.confirm(title,
                "Confirmation",
                {
                    confirmButtonText: "Continuar",
                    cancelButtonText: "No",
                    type: "warning"
                }).then(() => {
                    this.loading = true
                    provider.archiveAlert(idSelected).then((response) => {
                        Message({ type: 'success', message: 'Operación exitosa' })
                        this.loadData()
                    }).catch((err) => {
                        console.info(err)
                        Message({ type: 'error', message: 'An error ocurred' })
                        this.loading = false
                    })
                }).catch(()=>{
                    this.loading = false
                })
            }
        },
        getStageName(id){
            let stageName = ''
            if(this.stages.length > 0) {
                for (let i = 0; i < this.stages.length; i++) {
                    const s = this.stages[i]
                    if (s.id == id) {
                        stageName = s.name
                    }
                }
            }
            return stageName
        },
        formatter(row, column){
            return row
        }
    },
    watch: {
        resource(){
            this.loadData()
        },
        filters(){
            this.loadData()
        },
        paginationIdx(){
            this.loadData()
        },
        selectAll() {
            if(!_.isEmpty(this.dataArray)) {
                _.each(this.dataArray, (v)=> {
                v.selected = this.selectAll
                })
                this.showMenuValue = this.selectAll
            }
        }
    }
};
</script>
<style>
.el-select .el-input {
    width: 110px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
</style>
